import uuid from 'uuid/v1';
import { TYPES } from './constants';

export const TOAST_ADD = 'TOAST_ADD';
export const TOAST_REMOVE = 'TOAST_REMOVE';
export const TOAST_REMOVE_ALL = 'TOAST_REMOVE_ALL';

const createToastPayload = ({ message = 'Undefined toast message', type }) => ({
  id: uuid(),
  message,
  type,
});

const addToast = toast => ({
  type: TOAST_ADD,
  payload: toast,
});

export const removeToast = toast => ({
  type: TOAST_REMOVE,
  payload: toast,
});

export const removeAllToasts = () => ({
  type: TOAST_REMOVE_ALL,
});

export const showSuccessToast = message =>
  addToast(createToastPayload({ message, type: TYPES.SUCCESS }));

export const showFailureToast = message =>
  addToast(createToastPayload({ message, type: TYPES.FAILURE }));
